import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import {Observable, of} from 'rxjs';
import {map, catchError} from 'rxjs/operators';

import {UserService} from '../services/shared/user.service';
import {RoutingService} from '../services/routing.service';
import {AppSettingsService, SubdomainEnum} from '../services/app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class AlreadyLoggedInGuard  {
  constructor(private userService: UserService, private router: Router, private routingService: RoutingService, private appSettingsService: AppSettingsService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    boolean |
    UrlTree |
    Observable<boolean | UrlTree> |
    Promise<boolean | UrlTree> {
    const isLoggedIn = this.userService.isLoggedIn();
    if (!isLoggedIn) {
      if (this.appSettingsService.subDomain === SubdomainEnum.LP) {
        return this.userService.crossAppLogin()
          .pipe(
            map((response: any) => {
              if (response) {
                return this.router.parseUrl(this.routingService.defaultLoggedInPageBySubdomain);
              } else {
                return true;
              }
            }),
            catchError(err => {
              return of(true);
            })
          );
      } else {
        return true;
      }
    } else {
      return this.router.parseUrl(this.routingService.defaultLoggedInPageBySubdomain);
    }
  }
}
